module.exports = __webpack_public_path__ + "static/img/app-logo.e8f5dbad.png";